(() => {
  if (window.bb20CinemaLoaded) return;
  window.bb20CinemaLoaded = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const scenes = new Set();
  let pending = false;
  const clamp = n => Math.min(1, Math.max(0, n));
  const smooth = n => { const t = clamp(n); return t * t * (3 - 2 * t); };
  const paint = () => {
    pending = false;
    scenes.forEach(scene => {
      if (!scene.isConnected) { scenes.delete(scene); return; }
      const enabled = !reduced.matches && document.body.dataset.motion !== 'off';
      scene.classList.toggle('is-animated', enabled);
      const box = scene.getBoundingClientRect();
      const sticky = scene.querySelector('.cm-cinema-sticky');
      const nav = parseFloat(getComputedStyle(scene).getPropertyValue('--cm-nav-height'));
      const p = enabled ? clamp((nav - box.top) / Math.max(1, box.height - sticky.offsetHeight)) : 1;
      const story = clamp(p / .70);
      const gym = 1;
      const rack = 1;
      const attach = 1;
      const cap = 1;
      const insert = 1;
      scene.style.setProperty('--gym-opacity', gym.toFixed(3));
      scene.style.setProperty('--rack-opacity', rack.toFixed(3));
      scene.style.setProperty('--hero-ui', (enabled ? 1 - smooth(p / .14) : 0).toFixed(3));
      scene.style.setProperty('--scene-pan', `${(15 * smooth(p / .18)).toFixed(2)}vw`);
      scene.querySelector('.cm-cinema-bottom').inert = !enabled || p > .14;
      scene.querySelector('.cm-cinema-controls a').inert = !enabled || p > .14;
      scene.style.setProperty('--attach', attach.toFixed(3));
      scene.style.setProperty('--bag-scale', (1 - .2 * attach).toFixed(3));
      scene.style.setProperty('--bag-shift-x', `${(-4 * attach).toFixed(2)}%`);
      scene.style.setProperty('--bag-shift-y', `${(-5 * attach).toFixed(2)}%`);
      scene.style.setProperty('--rack-shift', `${(-30 * (1 - attach)).toFixed(2)}px`);
      scene.style.setProperty('--magnet-pulse', '0');
      const x = 300 * insert;
      const y = 150 - 30 * insert - 120 * Math.sin(Math.PI * insert);
      scene.style.setProperty('--bottle-x', `${(x / 440 * 100).toFixed(3)}%`);
      scene.style.setProperty('--bottle-y', `${(y / 440 * 100).toFixed(3)}%`);
      scene.style.setProperty('--cap-y', `${(-70 * (1 - cap)).toFixed(2)}%`);
      scene.style.setProperty('--cap-r', `${(-18 * (1 - cap)).toFixed(2)}deg`);
      scene.style.setProperty('--assembly-r', `${(enabled ? 4 * Math.sin(story * Math.PI * 2) * (1 - attach) : 0).toFixed(2)}deg`);
      scene.style.setProperty('--word-x', `${(8 - story * 22).toFixed(2)}%`);
      scene.style.setProperty('--intro-x', `${(story * 55).toFixed(2)}%`);
      scene.style.setProperty('--intro-opacity', `${(1 - smooth((story - .05) / .16)).toFixed(3)}`);
      scene.style.setProperty('--caption-opacity', `${smooth((story - .20) / .05).toFixed(3)}`);
      scene.style.setProperty('--story-progress', p.toFixed(3));
      scene.dataset.chapter = p >= .72 ? '3' : story < .34 ? '0' : story < .76 ? '1' : '2';
      scene.querySelectorAll('[data-cm-cinema-toggle]').forEach(button => {
        button.setAttribute('aria-pressed', String(!enabled));
        button.textContent = enabled ? button.dataset.pause : button.dataset.resume;
      });
    });
  };
  const requestPaint = () => { if (!pending) { pending = true; requestAnimationFrame(paint); } };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } });
  }, { threshold: .08 }) : null;
  const init = root => {
    root.querySelectorAll('[data-cm-cinema]').forEach(scene => {
      if (scenes.has(scene)) return;
      scenes.add(scene);
      scene.querySelector('[data-cm-cinema-toggle]').addEventListener('click', () => {
        const paused = document.body.dataset.motion !== 'off';
        document.body.dataset.motion = paused ? 'off' : 'on';
        document.querySelectorAll('[data-cm-motion]').forEach(button => {
          button.setAttribute('aria-pressed', String(paused));
          button.textContent = paused ? button.dataset.resume : button.dataset.pause;
        });
        requestPaint();
      });
    });
    if (observer && !reduced.matches) root.querySelectorAll('.cm-card,.cm-section-head,.cm-editorial-panel,.cm-faq').forEach((element, index) => {
      if (element.classList.contains('cm-reveal')) return;
      element.classList.add('cm-reveal');
      element.style.setProperty('--reveal-delay', `${index % 4 * 45}ms`);
      observer.observe(element);
    });
    requestPaint();
  };
  const start = () => {
    init(document);
    window.addEventListener('scroll', requestPaint, { passive: true });
    window.addEventListener('resize', requestPaint, { passive: true });
    reduced.addEventListener('change', requestPaint);
    new MutationObserver(requestPaint).observe(document.body, { attributes: true, attributeFilter: ['data-motion'] });
    document.addEventListener('shopify:section:load', e => init(e.target));
    document.addEventListener('shopify:section:unload', requestPaint);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

